import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="intro">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            Your trusted partner for critical security infrastructure, ensuring seamless operation at every stage
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 services-containt">
                  {" "}
                  <img src={d.img} alt="..." className="service-img" />
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div></div>
  );
};
